import translate from "../functions/translate";

export const AllFieldsRequired = () => (
    <span>
        {translate('all_fields_required')}
    </span>
);